import request from "@/plugins/axios"
//发票板式文件审核
let prefix = "eids-invoice/paper";

export function eidownloads(criteria) {
  return request({
    url: prefix + '/eidownloads/',
    method: 'post',
    data: criteria,
	  responseType: 'blob' 
  })
}
